import AutoloadViews from '@galaxy/modules/Core/resources/js/AutoloadViews';

// Init Lodash.
window._ = require('lodash');

// Include Concord module dependencies.
require('@galaxy/modules/Core/resources/js/sentry/withoutVue.js');
require('@galaxy/modules/Core/resources/js/View.js');
require('@galaxy/modules/Crud/resources/js/bootstrap.js');
//require('@galaxy/modules/Core/resources/js/vue.js');
require('@galaxy/modules/Canvas/resources/js/bootstrap.website.js');
require('@galaxy/modules/Website/resources/js/partials/cookies.js');
require('@galaxy/modules/Website/resources/js/common/statistics.js');
require('@galaxy/modules/Website/resources/js/common/livewireAndAlpine.js');
require('@galaxy/modules/Website/resources/js/common/debug.js');

// TODO Medium: Not a real overwrite anymore. Can we hook into require() to be able to overwrite files?
require('@galaxy/modules/Website/resources/js/partials/menu.js');

// Load app specific JS.
// TODO Concord: How to overwrite? Does 2nd arg work?
AutoloadViews.load('website', require.context('./website/', true, /.(js|vue)$/), require.context('./galaxy/website/', true, /.(js|vue)$/));
// AutoloadViews.load('components.website', require.context('./../components/website/', true, /.(js|vue)$/));
AutoloadViews.load('modules.website', require.context('./../../app/Modules/', true, /.(js|vue)$/));

// Load all modules
require('./../../app/Modules/Shop/resources/js/bootstrap.js');
AutoloadViews.load('search', require.context('./../../app/Modules/Search/', true, /.(js|vue)$/));
